export default {
  methods: {
    /**
     * Возвращает название фильтра по ключу
     * @param filterName Ключ
     * @returns {string}
     */
    getFilterText (filterName) {
      const filters = {
        ad_network_type: 'по площадкам',
        campaign_name: 'по кампаниям',
        criterion: 'по условиям показа',
        date: 'по дням',
        device: 'по устройствам'
      }
      return filters[filterName] !== undefined
        ? filters[filterName]
        : filters.device
    }
  }
}
